import UserDeleteAccountStore from './UserDeleteAccountStore'

export default UserDeleteAccountStore
